module.exports = __webpack_public_path__ + "img/reduniq.a9daf33c.webp";